import { AuthenticationProvider } from '@axa-fr/react-oidc-context'
import React, { lazy, Suspense } from 'react'
import { AuthConfiguration } from '../authentication/config'
import {
    NotAuthenticatedComponent,
    SessionLostComponent,
    CallbackComponent,
} from '../authentication/overrides'
import { UserProvider } from '../authentication/UserContext'
import { LoadingSplashScreen } from '@the-game/components'

const AuthedApp = lazy(() => import('./authed-app'))
export function App() {
    return (
        <AuthenticationProvider
            configuration={AuthConfiguration}
            callbackComponentOverride={CallbackComponent}
            sessionLostComponent={SessionLostComponent}
            notAuthenticated={NotAuthenticatedComponent}
        >
            <UserProvider>
                <Suspense fallback={<LoadingSplashScreen />}>
                    <AuthedApp />
                </Suspense>
            </UserProvider>
        </AuthenticationProvider>
    )
}

export default App
